<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('registerDate') }" class="colStyle">
      {{ items.storageMoveDate }}
    </div>
    <div v-bind:style="{ width: getWidth('shipTpLoading') }" class="colStyle">
      {{ `${items.shipStorage.name} → ${items.loadingStorage.name}` }}
    </div>
    <div v-bind:style="{ width: getWidth('userId') }" class="colStyle">
      {{ getUserName(items.user) }}
    </div>

    <!-- ステータス -->
    <div class="yCenter font-weight-bold">
      <span v-if="isDisplay('status')" class="yCenter operationAreaStyle mr-2">
        <span class="primary--text statusNameStyle mr-1">
          {{ getStatusName(items.status) }}
        </span>
        <NormalButton
          :text="buttonStatus.text"
          btnClass="pa-2"
          height="32px"
          width="70px"
          :disabled="buttonStatus.isComplete"
          @click="stockMoveOperationButton"
        />
        <StockMoveShipDialog
          v-model="ship.dialog"
          :title="$t('sale.sale_ship-operate')"
          width="80%"
          :recItems="items"
          @complete="pageReload"
        >
        </StockMoveShipDialog>
        <StockMoveLoadingDialog
          v-model="loading"
          :title="$t('loading.loading_loading-operation')"
          width="80%"
          :recItems="items"
          @complete="pageReload"
        >
        </StockMoveLoadingDialog>
      </span>

      <NormalButton
        text="common.input_status-history"
        btnClass="pa-2"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="statusHistory.dialog.dialog = true"
      />
      <StatusHistoryDialog
        v-model="statusHistory.dialog"
        pageType="StockMove"
        :tables="statusHistory.tables"
        itemKey=""
      />

      <NormalButton
        :text="$t('storage.storage_storage-move-detail')"
        height="32px"
        color="white"
        textColor="thinText--text"
        class="mx-2"
        btnClass="pa-2"
        :outlined="true"
        @click="detailDialog.dialog.dialog = true"
      />
      <StorageDetailDialog
        v-model="detailDialog.dialog"
        title="storage.storage_storage-move-confirm"
        width="80%"
        :recItems="items"
        @submit="pageReload"
      />
    </div>
  </div>
</template>
<script>
import {
  countryUtil,
  countryCallingCodeUtil,
  stockMoveUtil,
  storageUtil
} from '@/util'
import { stockMoveStatusHistory } from '@/config'

import NormalButton from '@/components/items/Buttons/NormalButton'
import StorageDetailDialog from '@/components/layouts/Dialogs/MultipleArea/StorageInfoDialog/StorageDetailDialog'

import {
  StockMoveShipDialog,
  StockMoveLoadingDialog,
  StatusHistoryDialog
} from '@/components/layouts/Dialogs'

import { mapActions } from 'vuex'

export default {
  components: {
    NormalButton,
    StockMoveShipDialog,
    StockMoveLoadingDialog,
    StatusHistoryDialog,
    StorageDetailDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  data: () => ({
    rowDialogMethodCommonName: 'rowDialogMethodCommon',

    detailDialog: {
      dialog: {
        dialog: false
      },
      pageInfoData: {}
    },
    complete: {
      dialog: {
        dialog: false,
        data: {
          id: '',
          date: ''
        },
        status: {
          name: '',
          isDisabled: false
        }
      }
    },
    ship: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    loading: { dialog: false },
    statusHistory: {
      dialog: { dialog: false },
      tables: [
        {
          title: '状態変更履歴',
          items: { default: [] },
          itemKey: ''
        }
      ]
    },
    payment: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    buttonStatus: {
      text: '',
      isComplete: false
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ini() {
      this.complete.dialog.data.id = this.items.shipId
      this.buttonStatus = {
        text: stockMoveUtil.getStockMoveButtonName(this.items.status),
        isComplete: stockMoveUtil.isStockMoveButtonDisable(this.items.status)
      }
      this.statusHistory.tables[0].items = this.items.storageMoveStatusHistories
      // this.quickFix.pageInfoData = {
      //   line1: {
      //     controlNumber: this.items.transaction.controlNumber,
      //     customerName: this.items.sale.customer.organizationName,
      //     storageName: this.items.storage.name,
      //     shipDate: this.items.shipDate,
      //     trackingNumber: this.items.trackingNumber,
      //     remarks: {
      //       data: this.items.shipNote ? this.items.shipNote.body : '',
      //       title: '',
      //       text: ''
      //     }
      //   },
      //   line2: {
      //     fullName: this.items.destName,
      //     // companyName: "",
      //     phone: {
      //       // TODO：APIのレスポンスはcodeで良いか
      //       countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
      //         this.items.destPhoneNumberCountryCode
      //       ),
      //       phoneNumber: this.items.destPhoneNumber
      //     },
      //     country: countryUtil.getCountryIdInfo(this.items.destCountryId),
      //     postalCode: this.items.destPostalCode,
      //     // TODO：入力欄を動的にする
      //     region: countryUtil.getRegionInfo(
      //       this.items.destCountryId,
      //       this.items.destRegionId
      //     ),
      //     address1: this.items.destAddress1,
      //     address2: this.items.destAddress2
      //   }
      // }
    },
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    getStorageName(id) {
      return storageUtil.getStorageById(id).name
    },
    getStatusName(status) {
      return stockMoveUtil.getStockMoveStatusName(status)
    },

    isDisplay(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? true : false
    },
    pageReload() {
      this.$emit(this.rowDialogMethodCommonName, 'reload')
    },
    stockMoveOperationButton() {
      switch (this.items.status) {
        case stockMoveStatusHistory.STATUS.STOCK:
          this.ship.dialog.dialog = true
          break
        case stockMoveStatusHistory.STATUS.SHIP:
          this.loading.dialog = true
          break
      }
    }
  },
  watch: {
    items: {
      deep: true,
      handler(val) {
        this.ini()
      }
    }
  },

  computed: {}
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
.statusNameStyle {
  width: 50px;
}
.operationAreaStyle {
  width: 120px;
}
</style>
